import {StyleSheet} from 'react-native';

import {indent, screenWidth} from '/constant/layout.constant';
import {
  alabaster,
  cloudLight,
  darkGray,
  denim,
  grayscale,
  white,
} from '/theme/color/on.color';
import {alto, codGray, mineShaft} from '/theme/color/secondary.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  link: {
    color: denim,
    fontWeight: '600',
  },
  headerContainer: {
    marginBottom: 10,
    flexDirection: 'row',
  },
  headerContainerLargeFont: {
    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },
  headerText: {
    color: codGray,
    flex: 1,
    fontSize: 16,
  },
  titleText: {
    fontWeight: '500',
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  optaText: {
    ...getFontFamily('bold'),
  },
  sideText: {
    color: mineShaft,
  },
  sideTextLargeFont: {
    width: '100%',
    marginTop: indent * 0.15,
  },
  incentiveTripContent: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: cloudLight,
    backgroundColor: white,
    padding: 16,
    marginRight: indent * 0.25,
    alignSelf: 'center',
    marginBottom: 15,
    width: screenWidth() - indent * 2,
    minHeight: 263,
  },
  subHeadingText: {
    fontSize: 14,
    color: darkGray,
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    marginVertical: indent * 0.5,
  },
  progressBarContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: indent,
    marginBottom: indent * 0.25,
  },
  circleIcon: {
    fontSize: 20,
    marginRight: indent * 0.5,
    color: grayscale,
  },

  emptyBox: {
    width: '90%',
    height: 12,
    backgroundColor: alto,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: alto,
    borderRadius: 3,
  },
  boxesContainer: {
    flexDirection: 'row',
    marginVertical: indent * 0.4,
    marginBottom: indent * 0.5,
    width: '90%',
    minHeight: 24,
    backgroundColor: alabaster,
    marginLeft: indent * 1.45,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: alto,
    borderRadius: 4,
  },
  dataContainer: {
    // Add appropriate style properties here
  },
  subHeading: {
    // Add appropriate style properties here
  },
});
